import {BaseFactory} from "../../../../infrastructure/factories/base-factory";
import {OddsDomainModel} from "../models/odds.domain-model";
import {OddsViewModel} from "../models/odds.view-model";
import {OddsApiModel} from "../models/odds.api-model";
import {BookmakerApiModel} from "../../bookmaker/models/bookmaker-api-model";
import {RateOptionFactory} from "../rate-option/domain-services/rate-option.factory";
import {BookmakerDomainModel} from "../../bookmaker/models/bookmaker-domain-model";
import {BookmakerFactory} from "../../bookmaker/domain-services/bookmaker-factory";
import {ODDS_TYPES} from "../../../../core/components/odds/components/odds-consts";
import {LoggerUtils} from "../../../../infrastructure/utils/logger/logger-utils";
import {TermsUtils} from "../../../../infrastructure/utils/terms-utils";
import {EXTRA_LINKS_CONTEXTS} from "../../../../core/app/consts";

//todo: remove!
export class OddsFactory extends BaseFactory {
  bookmakerFactory: BookmakerFactory;
  rateOptionFactory: RateOptionFactory;

  static injectables = [...BaseFactory.injectables, BookmakerFactory, RateOptionFactory];

  constructor(logger: LoggerUtils, terms: TermsUtils, bookmakerFactory: BookmakerFactory, rateOptionFactory: RateOptionFactory) {
    super(logger, terms);

    this.bookmakerFactory = bookmakerFactory;
    this.rateOptionFactory = rateOptionFactory;
  }

  createDomainModel(apiModel: OddsApiModel, bookmakers: Array<BookmakerApiModel>): OddsDomainModel {
    const bookmakerApi: BookmakerApiModel = apiModel.bookmaker || bookmakers.find((bookmaker: BookmakerApiModel) => apiModel.bookmakerId === bookmaker.id);
    const bookmakerDomain: BookmakerDomainModel = this.bookmakerFactory.createDomainModel(bookmakerApi);
    const domainObject: OddsDomainModel = new OddsDomainModel(apiModel, bookmakerDomain);

    return domainObject;
  }

  createVM(model: OddsDomainModel, oddsType: ODDS_TYPES, context: EXTRA_LINKS_CONTEXTS): OddsViewModel {
    const vm: OddsViewModel = new OddsViewModel(model, oddsType, context);

    return vm;
  }
}
